<template>
    <div class='revenue exportContainer'>
        <helpinfo :helpData="helpData"> </helpinfo>
        <div class="reex-pack">
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o"></i>
                </Button>
                <Button v-if="this.hasPermission('CC0702')"
                        slot="tootipL"
                        :loading="loading"
                        @click="exportData">
                    <i class="icon-export-1-o"
                       style="vertical-align: middle;"></i> {{$t('导出')}}</Button>
                <Button v-if="this.hasPermission('CC0702')"
                        slot="tootipL"
                        @click="toggleTask">
                    <i class="icon-export-1-o"
                       style="vertical-align: middle;"></i> {{$t('下载任务')}}</Button>
                <div slot="tootipR">
                    <DatePicker v-model="newDate"
                                type="datetimerange"
                                :dateOptions="dateOptions"
                                :clearable="false"
                                :editable='false'
                                placement="bottom-end"
                                :placeholder="$t('选择日期')"
                                format="yyyy-MM-dd HH:mm:ss"
                                @on-ok="dateChange"
                                @on-clear="dateClear"
                                transfer
                                style="width: 355px"></DatePicker>
                </div>
            </rcTable>
        </div>
        <downloadTaskModal :visible="showTaskModal"
                           type="bizAccountDeal"
                           @cancel="toggleTask" />
        <!-- <div v-if="loading">
            <Spin fix><span>{{$t('导出中')}}...</span></Spin>
        </div> -->
    </div>
</template>

<script>
import helpinfo from '@/views/components/basic/helpinfo'
import rcTable from '@/views/components/basic/rcTable'
import { formatDateTime } from '@/service/utils'
import API from '@/service/api'
import downloadTaskModal from '@/views/console/bills/components/downloadtaskmodal'
export default {
    name: 'deals',
    components: {
        helpinfo,
        rcTable,
        downloadTaskModal
    },
    data () {
        return {
            loading: false,
            helpData: {
                modelName: this.$t('收支明细')
            },
            dateOptions: {
                shortcuts: [
                    {
                        text: '1' + this.$t('小时'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 1)
                            return [start, end]
                        }
                    },
                    {
                        text: '12' + this.$t('小时'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 12)
                            return [start, end]
                        }
                    },
                    {
                        text: '1' + this.$t('天'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            return [start, end]
                        }
                    },
                    {
                        text: '7' + this.$t('天'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            return [start, end]
                        }
                    }
                ]
            },
            newDate: [],
            tradeChannelLabel: {
                wechatPay: this.$t('微信'),
                alipay: this.$t('支付宝'),
                unionpay: this.$t('银联'),
                platform: this.$t('平台'),
                acctCash: this.$t('现金余额'),
                accCredit: this.$t('信用余额'),
                // coupon: this.$t('优惠券'),
                balanceCash: this.$t('充值现金券'),
                deductBalanceCash: this.$t('抵扣现金券')
            },
            tradeTypeLabel: {
                charge: this.$t('充值'),
                pay: this.$t('消费'),
                refund: this.$t('退款')
            },
            typeLabel: {
                in: this.$t('收入'),
                out: this.$t('支出')
            },
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.ACCOUNT_DEALS),
                    params: {
                        startTime: null,
                        endTime: null
                    }
                },
                searchColumns: [
                    {
                        key: 'flowNoLike',
                        title: this.$t('交易编号'),
                        searchDefaultValue: ''
                    }
                    // {
                    //     key: 'actionUserName',
                    //     title: this.$t('操作者'),
                    //     searchDefaultValue: ''
                    // }
                ],
                searchShow: true,
                tableSearchKey: 'flowNoLike', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                columnsChooseShow: true,
                referenceVal: 1950,
                columns: [
                    {
                        title: this.$t('交易编号'),
                        key: 'flowNoLike',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 160,
                        render: (h, params) => {
                            const txt = params.row.flowNo
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('交易时间'),
                        key: 'createdDt',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            const txt = params.row.createdDt
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('账户ID'),
                        key: 'accountSid',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 160,
                        render: (h, params) => {
                            const { accountId } = params.row
                            return h('span', { class: 'tbl-operate', attrs: { title: this.$t(accountId) } }, accountId || '--')
                        }
                    },
                    {
                        title: this.$t('账户名称'),
                        key: 'entityName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        searchType: 'select',
                        filterMultiple: false,
                        render: (h, params) => {
                            const { entityName } = params.row
                            return h('span', { class: 'tbl-operate', attrs: { title: this.$t(entityName) } }, entityName || '--')
                        }
                    },
                    {
                        title: this.$t('客户名称'),
                        key: 'accountName',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            const txt = params.row.accountName
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('收支类型'),
                        key: 'type',
                        columnShow: true,
                        // disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        filterMultiple: false,
                        filters: [
                            { value: 'in', label: this.$t('收入') },
                            { value: 'out', label: this.$t('支出') }
                        ],
                        searchType: 'select',
                        render: (h, params) => {
                            const txt = this.typeLabel[params.row.type]
                            return h('span', { attrs: { title: txt }, class: params.row.type === 'out' ? 'balance-color' : 'balance-color-green' }, txt)
                        }
                    },
                    {
                        title: this.$t('交易类型'),
                        key: 'tradeType',
                        columnShow: true,
                        // disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        filterMultiple: false,
                        filtersKey: '',
                        filters: [
                            { value: 'charge', label: this.$t('充值') },
                            { value: 'pay', label: this.$t('消费') },
                            { value: 'refund', label: this.$t('退款') }
                        ],
                        searchType: 'select',
                        render: (h, params) => {
                            const txt = this.tradeTypeLabel[params.row.tradeType]
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('交易渠道'),
                        key: 'tradeChannel',
                        columnShow: true,
                        // disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        filterMultiple: false,
                        filtersKey: '',
                        filters: [
                            // { value: 'balanceCash', label: this.$t('现金券') },
                            { value: 'alipay', label: this.$t('支付宝') },
                            { value: 'wechatPay', label: this.$t('微信') },
                            { value: 'unionpay', label: this.$t('银联') },
                            { value: 'platform', label: this.$t('平台') },
                            { value: 'acctCash', label: this.$t('现金余额') },
                            { value: 'accCredit', label: this.$t('信用余额') },
                            // { value: 'coupon', label: this.$t('优惠券') }
                            { value: 'balanceCash', label: this.$t('充值现金券') },
                            { value: 'deductBalanceCash', label: this.$t('抵扣现金券') }
                        ],
                        searchType: 'select',
                        render: (h, params) => {
                            const txt = this.tradeChannelLabel[params.row.tradeChannel]
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('交易渠道流水号'),
                        key: 'tradeNoLike',
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 170,
                        render: (h, params) => {
                            const { envName, envType, tradeNo } = params.row
                            const isShow = (envName !== null && envName.length !== 0)
                            return h(isShow ? 'Poptip' : 'div', {
                                props: {
                                    trigger: 'hover'
                                }
                            }, [
                                h('span', { attrs: { title: tradeNo }, class: { ellipsis: true } }, tradeNo),
                                h('div', { slot: 'content', class: isShow ? 'env-name-pack' : 'isShow env-name-pack' }, [
                                    h('i', { class: this.envIcon(envType) }),
                                    h('span', { attrs: { title: envName } }, envName)
                                ])
                            ])
                        }
                    },
                    {
                        title: this.$t('订单号'),
                        key: 'orderNoLike',
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 160,
                        render: (h, params) => {
                            const txt = params.row.orderNo
                            return h('a', { attrs: { title: txt }, on: { click: () => { txt && this.$router.push({ path: '/mgt/orders/' + txt }) } } }, txt || '--')
                        }
                    },
                    {
                        title: this.$t('账单号'),
                        key: 'billNoLike',
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 160,
                        render: (h, params) => {
                            const txt = params.row.billNo
                            return h('span', { attrs: { title: txt } }, txt || '--')
                        }
                    },
                    {
                        title: this.$t('备注'),
                        key: 'remark',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            const txt = params.row.remark
                            return h('span', { attrs: { title: txt } }, this.$t(txt))
                        }
                    },
                    {
                        title: this.$t('账期'),
                        key: 'billingCycle',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 80,
                        render: (h, params) => {
                            const txt = params.row.billingCycle
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('金额'),
                        key: 'amount',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        align: 'right',
                        className: 'ellipsis',
                        resizable: true,
                        width: 140,
                        render: (h, params) => {
                            const txt = this.$money(params.row.amount)
                            return h('span', { attrs: { title: txt }, class: params.row.type === 'out' ? 'balance-color' : 'balance-color-green' }, txt)
                        }
                    },
                    {
                        title: this.$t('现金余额'),
                        key: 'balance',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        align: 'right',
                        className: 'ellipsis',
                        resizable: true,
                        width: 160,
                        render: (h, params) => {
                            const txt = this.$money(params.row.balance)
                            return h('span', { attrs: { title: txt }, class: 'balance-color' }, txt)
                        }
                    },
                    // {
                    //     title: this.$t('账户ID'),
                    //     key: 'accountSid',
                    //     disabledSearch: true,
                    //     columnShow: true,
                    //     columnsChoosed: false,
                    //     className: 'ellipsis',
                    //     resizable: true,
                    //     width: 160,
                    //     render: (h, params) => {
                    //         const txt = params.row.accountSid
                    //         return h('span', { attrs: { title: txt } }, txt)
                    //     }
                    // },
                    {
                        title: this.$t('充值现金券余额'),
                        key: 'balanceCash',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        align: 'right',
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        sortable: true,
                        render: (h, params) => {
                            const txt = this.$money(params.row.balanceCash)
                            return h('span', { attrs: { title: txt }, class: 'balance-color' }, txt)
                        }
                    },
                    // {
                    //     title: this.$t('抵扣现金券支付金额'),
                    //     key: 'deductBalanceCash',
                    //     disabledSearch: true,
                    //     columnShow: true,
                    //     columnsChoosed: true,
                    //     className: 'ellipsis',
                    //     resizable: true,
                    //     align: 'right',
                    //     minWidth: 150,
                    //     render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.deductBalanceCash } }, this.$money(params.row.deductBalanceCash))
                    // },
                    {
                        title: this.$t('信用余额'),
                        key: 'balanceCredit',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        align: 'right',
                        sortable: true,
                        className: 'ellipsis',
                        // resizable: true,
                        minWidth: 150,
                        // renderHeader: (h, params) => h('div', { style: { paddingRight: '35px' } }, this.$t('信用余额')),
                        render: (h, params) => {
                            const txt = this.$money(params.row.balanceCredit)
                            return h('span', { style: { paddingRight: '0px' }, attrs: { title: txt }, class: 'balance-color' }, txt)
                        }
                    },
                    {
                        title: this.$t('收费规则'),
                        key: 'chargingType',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        width: 100,
                        resizable: true,
                        render: (h, { row }) => {
                            const txt = this.$t({ '01': '正常计费', '02': '销售计费' }[row.chargingType || '01'])
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    }
                ]
            },
            showTaskModal: false
        }
    },
    mounted () {
        if (this.$route.query.isSuccess) {
            this.$Message.success(this.$t('充值成功'))
        }
    },
    created () {
        // 默认搜索 订单编号
        const flowNo = this.$route.query.flowNo
        if (flowNo) {
            this.tableAttr.searchColumns[0].searchDefaultValue = flowNo
        }
        if (sessionStorage.ts_list && JSON.parse(sessionStorage.ts_list)[this.tableAttr.tableSearchKey]) {
            this.tableAttr.searchDefaultValueList = JSON.parse(sessionStorage.ts_list)[this.tableAttr.tableSearchKey]
        }
        // 处理账户名称筛选下拉数据
        const accountList = this.$store.state.user.accountInf.accountlist
        const index = this.tableAttr.columns.findIndex(col => col.key === 'entityName')
        this.tableAttr.columns[index].filters = accountList.map(item => {
            return { label: item.entityName, value: item.entityName }
        })
    },
    methods: {
        refresh () {
            this.$refs.rcTable.refreshTable()
        },
        // 选择时间
        dateChange () {
            const data = {}
            if (this.newDate && this.newDate[0] && this.newDate[1]) {
                data.startTime = this.newDate[0] ? formatDateTime(this.newDate[0]) : ''
                data.endTime = this.newDate[1] ? formatDateTime(this.newDate[1]) : ''
            }
            this.$refs.rcTable.refreshTable(data, true)
        },
        dateClear () {
            this.newDate = [null, null]
            this.dateChange()
        },
        exportData () {
            this.loading = true
            const params = this.$refs.rcTable.searchValueList.map(item => `${item.key}=${item.value}`).join('&')
            const time = this.newDate[0] && this.newDate[1] ? `startTime=${formatDateTime(this.newDate[0])}&endTime=${formatDateTime(this.newDate[1])}&` : ''
            let url = this.urlFormat(API.ACCOUNT_DEALS_EXPORT + '?groupByFlag=bizAccountDeal&' + time + params, false)
            if (time.length === 0 && params.length === 0) {
                url = this.urlFormat(API.ACCOUNT_DEALS_EXPORT + '?groupByFlag=bizAccountDeal', false)
            }
            this.axios.get(url).then(res => {
                this.loading = false
            }).catch(e => {
                this.loading = false
            })
        },
        toggleTask () {
            this.showTaskModal = !this.showTaskModal
        }
    }
}
</script>
<style lang="less" scoped>
.reex-pack {
    padding: 15px;
}
</style>
<style lang="less">
.revenue {
    position: relative;
    height: calc(~'100% - 50px');
    div {
        .isShow {
            display: none;
        }
    }
}
.exportContainer .ivu-spin-text {
    display: block !important;
    margin-left: -12px;
    margin-top: 5px;
}
</style>
